<template>
  <div v-if="funcTypeData.type == 'Enhance'" style="background-color: #ffffff66;"
    class="rounded-[30px] h-[280px] w-[82%] shadow-[0_8px_30px_0px_rgba(200,200,232,0.25)] relative  mt-5"
    @click="addEventLog('funcType-upload-click')">
    <div class="h-full w-full flex items-center justify-center px-5">
      <div class="min-w-[409px] min-h-[323px] -translate-y-[15px] -translate-x-[35px]">
        <NuxtImg width="409" height="323" :src="funcTypeData.src" :alt="funcTypeData.title" loading="lazy" class="">
        </NuxtImg>
      </div>
      <div class="w-[600px] h-full py-6">
        <div :class="{ 'bg_upload': bgMouse }"
          class="w-full h-full flex flex-col bg-opacity-60 bg-white items-center justify-center px-6 text-center rounded-[25px] outline-2 outline-mainColors cursor-pointer">
          <NuxtImg width="48" height="48" alt="upload" loading="lazy" class="w-[48px] h-[48px]"
            src="/assets/images/functype/allTools/newImgs/tool-upload.webp"></NuxtImg>
          <span class="text-text-deep font-Roboto-Bold font-bold text-2xl">
            {{ $t('upload-image') }}</span>
          <!-- <div class="Roboto-16 opacity-60">{{ $t("upload-image-desc") }}</div> -->
          <div v-if="funcType != 'png_hd'" class="w-full mt-[20px] text-text-gray line-clamp-[2] md:line-clamp-[4]">
            {{ fileType == FileType.video ? $t("index-upload-video-desc", { format: acceptList.join("\\") }) :
              $t(isBaseFunc ? 'index-upload-desc' : "index-upload-one-desc", { format: acceptList.join("\\") }) }}
          </div>
          <div v-else class="w-full mt-[20px] text-text-gray line-clamp-[2] md:line-clamp-[4]">
            {{ $t("funcType-upload-png") }}
          </div>
        </div>
      </div>
      <EnhanceUpload :acceptList="acceptList" drop :fileType="fileType" class="absolute h-full w-full right-0 opacity-0"
        @mouseenter="bgMouse = true" @mouseleave="bgMouse = false" :acceptCount="acceptCount"></EnhanceUpload>
    </div>
  </div>
  <div v-else @click="addEventLog('funcType-upload-click')">
    <GradientsBtn text="" class="h-16 w-fit z-[2] px-2" :enable="true">
      <template #prefix>
        <!-- <svg width="24" height="24" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_1573_3193)">
            <path
              d="M13.6032 20.8034C13.6223 21.2278 13.4828 21.644 13.2116 21.971C12.9405 22.2981 12.5574 22.5124 12.1368 22.5722C9.06 22.9442 6.8544 23.897 5.4648 25.3802C4.0824 26.849 3.3672 28.7642 3.3072 31.0202C3.5232 33.437 4.32 35.249 5.7 36.545C7.0728 37.8338 9.1344 38.5178 11.9472 38.537L37.5552 38.5394C39.9456 38.3786 41.7072 37.4738 42.9576 35.8058C44.5392 33.7034 44.8704 31.8098 44.5944 29.693C44.388 28.1042 43.4064 26.0882 41.8176 24.7178C40.6056 23.6714 38.6976 23.0354 36.0552 22.8698C35.1576 22.8146 34.4688 22.0226 34.4952 21.0866C34.6041 18.4825 33.8331 15.9175 32.3064 13.805C30.2136 10.853 26.9712 9.3482 23.784 9.4706C20.6664 9.5906 17.7792 11.0618 15.6936 13.8434C14.2248 15.8018 13.5336 18.0962 13.6032 20.8034ZM34.9704 11.7434C36.6191 14.0351 37.592 16.7432 37.7784 19.5602C40.344 19.9106 42.3984 20.7266 43.9296 22.0466C46.1952 24.0026 47.568 26.8154 47.88 29.225C48.2664 32.1938 47.772 35.009 45.5664 37.9442C43.7088 40.4162 41.0664 41.7746 37.6584 42.0002H11.9352C8.3616 41.9762 5.5224 41.0354 3.4824 39.1202C1.452 37.2146 0.2928 34.589 0 31.1402C0.072 27.8378 1.104 25.0802 3.096 22.9562C4.8168 21.1202 7.236 19.9322 10.3176 19.3538C10.5 16.4858 11.4216 13.9226 13.0848 11.7098C15.7848 8.105 19.5912 6.1682 23.6616 6.0122C27.9048 5.849 32.2032 7.841 34.9704 11.7434ZM23.232 17.1242L18.48 22.025C18.1641 22.3503 17.986 22.785 17.9829 23.2384C17.9798 23.6919 18.1518 24.129 18.4632 24.4586C18.6167 24.6169 18.8007 24.7424 19.004 24.8276C19.2074 24.9129 19.4259 24.956 19.6464 24.9544C19.8669 24.9528 20.0848 24.9066 20.2869 24.8185C20.489 24.7304 20.6712 24.6023 20.8224 24.4418L22.7112 22.4954V32.669C22.7112 33.545 23.3352 34.2698 24.1464 34.385L24.372 34.4018C25.2864 34.4018 26.028 33.6242 26.028 32.669V22.4594L27.9024 24.3938C28.0559 24.5525 28.2401 24.6783 28.4436 24.7638C28.6472 24.8492 28.866 24.8924 29.0868 24.8909C29.3076 24.8893 29.5257 24.8429 29.7281 24.7546C29.9304 24.6663 30.1127 24.5378 30.264 24.377C30.5796 24.0514 30.7572 23.6165 30.7599 23.1631C30.7626 22.7097 30.5901 22.2727 30.2784 21.9434L25.5912 17.1122C25.4379 16.9538 25.254 16.828 25.0507 16.7426C24.8475 16.6572 24.629 16.6139 24.4085 16.6152C24.188 16.6166 23.9701 16.6626 23.7679 16.7505C23.5657 16.8383 23.3834 16.9639 23.232 17.1242Z"
              fill="#FFFFFF" />
          </g>
          <defs>
            <clipPath id="clip0_1573_3193">
              <rect width="48" height="48" fill="white" />
            </clipPath>
          </defs>
        </svg> -->
        <NuxtImg width="24" height="24" alt="upload" loading="lazy"
          src="/assets/images/functype/allTools/newImgs/upload.webp"></NuxtImg>
      </template>
      <template #suffix>
        <div class="text-left">
          <div class="Roboto-Bold-20">{{ $t("upload-image") }}</div>
          <div class="Roboto-12 text-white opacity-60">{{ $t("upload-image-desc") }}</div>
        </div>
      </template>
    </GradientsBtn>
    <EnhanceUpload :acceptList="acceptList" drop :fileType="fileType"
      class="absolute z-[2] -translate-y-[64px] h-16 w-[257px] opacity-0" @mouseenter="bgMouse = true"
      @mouseleave="bgMouse = false" :acceptCount="acceptCount"></EnhanceUpload>
  </div>
</template>
<script setup lang="ts">
import { funcTypeAcceptList } from "@/utils/index";
import { FileType } from "@/utils/type";
const { locale, t } = useI18n();
const { checkIsBaseFunc } = useFuncType()
const props = defineProps({
  acceptCount: {
    type: Number,
    default: 1,
  },
  title: {
    type: String,
    default: "",
  },
  funcType: {
    type: String,
    default: "",
  },
  funcTypeData: {
    type: Object,
    default: {},
  },
});
const bgMouse = ref(false)
const acceptList = ref(funcTypeAcceptList(props.funcType.toLocaleLowerCase()));
if (props.funcType == 'png_hd') {
  acceptList.value = ['png']
}
const fileType = ref(
  props.funcType.toLocaleLowerCase().includes("video") ? FileType.video : FileType.image
);
const isBaseFunc = ref(checkIsBaseFunc(props.funcType.toLocaleLowerCase()))
const addEventLog = (name: string) => {
  useLogEvent({ eventName: name });
}
</script>
<style scoped>
.bg_upload {
  background-color: #5e45ff1c;
}

.outline-mainColors {
  border: 2px dashed #C4BAFF;
}
</style>